module.exports = __webpack_public_path__ + "img/sushidonutsfrontal.fe2d2760.png";